export enum AssigneesSearchResultLevel {
    GLOBAL,
    INTERNATIONAL,
    DOMESTIC,
    PCC,
    SEARCH
}
